import ClientDetails from "./pages/ClientDetails";
import { createBrowserRouter, RouterProvider, Outlet, Navigate } from "react-router-dom";
import { ConfirmProvider } from "./components/ConfirmProvider";
import { NavigationGuard } from "./hooks/useUnsavedChanges";

import Abonnements from "./pages/Abonnements";
import Clients from "./pages/Clients";
import Dashboard from "./pages/Dashboard";
import Devis from "./pages/Devis";
import SignatureDevis from "./pages/SignatureDevis";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import MarkdownPdf from "./pages/MarkdownPdf";
import NewFacture from "./pages/NewFacture";
import Parametres, { ChangePasswordSection } from "./pages/Parametres";
import Prestations from "./pages/Prestations";
import PrivateRoute from "./components/PrivateRoute";
import React from "react";
import Taches from "./pages/Taches";
import { Toaster } from "react-hot-toast";

const router = createBrowserRouter([
  { path: "/signature/:token", element: <SignatureDevis /> },
  { path: "/login", element: <Login /> },
  {
    element: <PrivateRoute><NavigationGuard><Layout><Outlet /></Layout></NavigationGuard></PrivateRoute>,
    children: [
      { path: "/", element: <Dashboard /> },
      { path: "/factures", element: <Dashboard invoicesOnly /> },
      { path: "/clients", element: <Clients /> },
      { path: "/clients/:id", element: <ClientDetails /> },
      { path: "/taches", element: <Taches /> },
      { path: "/prestations", element: <Prestations /> },
      { path: "/devis", element: <Devis /> },
      { path: "/markdown-pdf", element: <MarkdownPdf /> },
      { path: "/abonnements", element: <Abonnements /> },
      { path: "/factures/nouvelle", element: <NewFacture /> },
      { path: "/factures/:id/edit", element: <NewFacture /> },
      { path: "/parametres", element: <Parametres /> },
      { path: "/securite", element: <div className="card mx-auto max-w-xl"><h1 className="mb-4 text-xl font-semibold">Sécuriser votre accès</h1><p className="mb-4 text-sm text-gray-600">Remplacez le mot de passe initial pour accéder à vos données.</p><ChangePasswordSection /></div> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

function App() {
  return <ConfirmProvider><div className="min-h-screen bg-gray-50">
    <RouterProvider router={router} /><Toaster position="top-right" />
  </div></ConfirmProvider>;
}

export default App;
